import { useCallback, useState, useRef } from 'react';
import {
  DEFAULT_TABLE_STATE,
  TableState,
} from 'src/components/DataTable/types/DataTable';

export interface UseTableStateReturn<TFilters> {
  tableState: TableState<TFilters>;
  initialState: Partial<TableState<TFilters>>;
  setQuery: (query: string) => void;
  setPage: (page: number) => void;
  resetState: () => void;
}

export function useTableState<TFilters>(
  initialState?: Partial<TableState<TFilters>>
): UseTableStateReturn<TFilters> {
  const initialStateRef = useRef(initialState);

  const [tableState, setTableState] = useState({
    ...DEFAULT_TABLE_STATE,
    ...initialState,
  } as TableState<TFilters>);

  const setQuery = useCallback((query: string): void => {
    setTableState((prevState) => ({
      ...prevState,
      query,
      page: 1,
    }));
  }, []);

  const setPage = useCallback((page: number): void => {
    setTableState((prevState) => ({
      ...prevState,
      page,
    }));
  }, []);

  const resetState = useCallback((): void => {
    setTableState({
      ...DEFAULT_TABLE_STATE,
      ...initialStateRef.current,
    } as TableState<TFilters>);
  }, []);

  return {
    tableState,
    initialState: initialStateRef.current,
    setQuery,
    setPage,
    resetState,
  };
}
